import * as React from 'react';
import { ReactNode, useContext } from 'react';
import { getPaymentMethod } from '../../../../../api/ProspectUserProfile';
import { useFetch } from '../../../../../hooks/useFetch';
import FormValidationDisplay from '../../../../common/form/ValidationDisplay';
import { LoadingDisplay } from '../../../../common/LoadingOverlay';
import { PropertyContext, TourPage, tourSignupPath } from '../TourRouter';
import { ConfirmationSection } from './ConfirmationSection';
import { isCreditCardExpired } from '../../../../../utilities/Utils';
import { formatCreditCardExpiration } from '../../../../../utilities/formatting';
import { browserHistory } from '../../../../../utilities/history';

interface Props {
    guestCardGuid: string;
}

const CreditCardConfirmationSection = (props: Props) => {
    const property = useContext(PropertyContext);
    if (!property) {
        return null;
    }

    const { data, error, loading } = useFetch(() => getPaymentMethod(), [], undefined);

    const CurriedConfirmationSection = (subProps: { hasIssue?: boolean; children?: ReactNode }) => (
        <ConfirmationSection
            headerText="Credit Card"
            onEditClick={() =>
                browserHistory.push(
                    tourSignupPath(property.slug, props.guestCardGuid)(TourPage.CcQualification)
                )
            }
            hasIssue={subProps.hasIssue}
        >
            {subProps.children}
        </ConfirmationSection>
    );

    if (loading) {
        return (
            <CurriedConfirmationSection>
                <LoadingDisplay />
            </CurriedConfirmationSection>
        );
    }

    if (!data || error) {
        return (
            <CurriedConfirmationSection hasIssue={true}>
                <FormValidationDisplay errorMessage={error || 'No credit card for user'} />
            </CurriedConfirmationSection>
        );
    }

    if (isCreditCardExpired(data.expirationDate)) {
        return (
            <CurriedConfirmationSection hasIssue={true}>
                <FormValidationDisplay
                    errorMessage={`Card expired ${formatCreditCardExpiration(data.expirationDate)}`}
                />
            </CurriedConfirmationSection>
        );
    }

    return <CurriedConfirmationSection hasIssue={false} />;
};

export default CreditCardConfirmationSection;



// WEBPACK FOOTER //
// ./src/components/pages/prospect/signup/confirmation/CreditCardConfirmationSection.tsx